module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/hidden-keys.js
// module id = 342
// module chunks = 1